import { render, staticRenderFns } from "./DetailMember.vue?vue&type=template&id=0b3b1cb2&scoped=true&"
import script from "./DetailMember.vue?vue&type=script&lang=js&"
export * from "./DetailMember.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3b1cb2",
  null
  
)

export default component.exports